export const MAIN_PLL_URL = 'premierlacrosseleague.com'
export const API_ROOT_URL = `${process.env.REACT_APP_API_BASE_ROUTE}/api`
export const GAMIFICATION_ROOT_URL = `${process.env.REACT_APP_GAMIFICATION_BASE_ROUTE}`
export const API_ROOT_WP = `https://${MAIN_PLL_URL}/wp-json/wp`
export const FLAG_URL = `https://${MAIN_PLL_URL}/wp-content/uploads/2021/03/`
export const PLL_IMAGE_URL = `https://${MAIN_PLL_URL}/wp-content/uploads`
export const Team_LOGO_URL = `https://img.${MAIN_PLL_URL}/Teams`
export const BROADCAST_IMG = `https://img.${MAIN_PLL_URL}/Logos`
export const REVERSE_BROADCAST_IMG = `https://img.${MAIN_PLL_URL}/Logos`
export const NEW_PLL_IMAGE_URL = `https://img.${MAIN_PLL_URL}`
export const CNBC_IMG = `https://${MAIN_PLL_URL}/wp-content/uploads/2021/07`
export const ADD_EVENT_SCRIPT = 'https://addevent.com/libs/atc/1.6.1/atc.min.js'
export const TWITTER_SCRIPT = 'https://platform.twitter.com/widgets.js'
export const FEVO_SCRIPT = 'https://offer.fevo.com/js/fevo.js'
export const TICKET_PRESALE = 'https://pllform.typeform.com/to/d9F9A8Iq'
export const TICKET_FAQS_URL = 'https://premierlacrosseleague.com/2022-ticket-faqs'
export const GROUP_TICKETS_PHONE = `310-928-1107`
export const GRAPHQL_ROOT_URL = process.env.REACT_APP_GRAPH_ROOT_URL || ''
export const GRAPHQL_ACCESS_KEY = process.env.REACT_APP_GRAPHQL_AUTH_KEY || ''
export const APP_LINK_BASE_URL =
  process.env.REACT_APP_DOMAIN_URI_PREFIX || 'https://pllmain.page.link'
  export const BRANCH_BASE_URL = process.env.REACT_APP_BRANCH_BASE_URL || 'https://pll.gg'
export const HOMEPAGE_BANNER = `https://${MAIN_PLL_URL}/wp-content/uploads/2021/02/cta@2x.png`
export const CHAMPIONSHIP_SERIES = `/championship-series`
export const windowSize = window.innerWidth

export const PLL_LINKS = {
  schedule: `/schedule`,
  tickets: `/tickets`,
  shop: `https://shop.${MAIN_PLL_URL}`,
  stats: `https://stats.${MAIN_PLL_URL}`,
  academy: `https://${MAIN_PLL_URL}/academy`,
  pllPlay: `https://${MAIN_PLL_URL}/play`,
  assists: `https://${MAIN_PLL_URL}/pll-assists/`,
  media: `https://${MAIN_PLL_URL}/media/`,
  matchup: `https://${MAIN_PLL_URL}/matchup`,
  draftCentral: `/draft-central`,
  rules: `https://pll-public-prod.s3.us-east-1.amazonaws.com/lacrosse/rules/2025+PLL+Rulebook.pdf`,
  playerHighlights: `https://www.youtube.com/playlist?list=PLYwxet-wh_uaDuXUXBObxHMPILR7dpuxX`,
  gameHighlights: 'https://www.youtube.com/channel/UCNUOJo_m8-w2yPSIC5DLK1g',
  youtubeChannel: 'https://www.youtube.com/channel/UCNUOJo_m8-w2yPSIC5DLK1g',
  pickem: `https://f2p.${MAIN_PLL_URL}/pickem`,
  predictor: `https://f2p.${MAIN_PLL_URL}/predictor`,
  watch: `https://plus.espn.com/pll`,
  allstar: `/all-star`,
  allstarVote: `/all-star-vote`,
  bracketChallenge: `https://f2p.${MAIN_PLL_URL}/bracket`,
  playerTransactions: `https://www.${MAIN_PLL_URL}/transactions`,
  generalAppLink: `https://pll.gg/home-download`,
  homepageAppLink: `https://pll.gg/home-download`,
  homeCardAppLink: `https://pll.gg/home-download`,
  getAlertsAppLink: `https://pllmain.page.link/get-alerts`,
  predictions: `https://www.${MAIN_PLL_URL}/predictions`,
  predictionTableSrc: `https://datawrapper.dwcdn.net/CqAa3/21/`,
  championshipSeriesTickets: `https://${MAIN_PLL_URL}${CHAMPIONSHIP_SERIES}/tickets`,
  myTickets: `https://pll.gg/qrDfv9KD6Hb`,
  cityVoting: `/home-cities-voting`,
  plln: `https://pll.gg/join-plln-web`,
  playoffStars: `https://www.${MAIN_PLL_URL}/playoff-stars/how-to-collect`,
  claimClub: `https://www.${MAIN_PLL_URL}/home-cities`,
  homecomingPassClub: `https://www.${MAIN_PLL_URL}/homecoming-passes`,
  howardHead: `https://www.youtube.com/watch?v=Q7km3j27d18&t=6s`,
  steadman: `https://www.youtube.com/watch?v=Q7km3j27d18&t=6s`,
}

export const PLL_IMAGES = {
  pllShield: `${PLL_IMAGE_URL}/2019/03/pll_logo.png`,
  pllShop:
    'https://cdn.zeplin.io/5e6a74ccf18e5310eed49ecf/assets/B9313CB0-F22B-424C-889D-791818477CF4.png',
  stats: `${PLL_IMAGE_URL}/2021/03/PLLStats.png`,
  academyWatermark: `${PLL_IMAGE_URL}/2023/04/academyWatermark.png`,
  academyVerified: `${PLL_IMAGE_URL}/2023/04/verified_logo.png`,
  academy: `${PLL_IMAGE_URL}/2023/04/PLLA_Logo.png`,
  pllPlay: `${PLL_IMAGE_URL}/2024/03/PLL-Play-Primary.webp`, 
  defaultProfile: `${PLL_IMAGE_URL}/2024/05/Headshot_generic_nobackground.webp`,
  assists: `${PLL_IMAGE_URL}/2021/03/PLLAssists.png`,
  draftLogo: `${PLL_IMAGE_URL}/2024/03/CollegeDraft-2024.webp`,
  pickem: `${PLL_IMAGE_URL}/2021/05/PLL_PickEm_Logo__Favicon.png`,
  gamedayHub: `${PLL_IMAGE_URL}/2023/02/PLL_GamedayHub_WebBanner.png`,
  bracketChallenge: `${PLL_IMAGE_URL}/2021/08/bracket_logo@3x.png`,
  pllGoldLogo: `${PLL_IMAGE_URL}/2021/08/PLL_Playoff_logo.png`,
  champSeriesLogo: {
    webp: `https://premierlacrosseleague.com/wp-content/uploads/2024/12/2025_champ_series_PLL_primary.webp`,
    fallback: `https://premierlacrosseleague.com/wp-content/uploads/2024/12/2025_champ_series_PLL_primary.webp`,
  },
  pllAppLogo: `https://img.${MAIN_PLL_URL}/Teams/2022/Logo/pll-app-icon.jpg`,
  pllAppFeaturedImage: `${PLL_IMAGE_URL}/2022/04/AppFormstack-scaled.jpg`,
  pllAppHomeCardCalloutImg: `${PLL_IMAGE_URL}/2023/04/AppDownload-bg.png`,
  allStarCallout: `https://${MAIN_PLL_URL}/2022_asg_hero`,
  allStarSkillsCallout: `https://${MAIN_PLL_URL}/2022_skills_hero`,
  allStarVoteLogo: `${PLL_IMAGE_URL}/2025/06/ASG_Primary.webp`,
  bracketBackground: `https://${MAIN_PLL_URL}/2022_pllbracket_bg_final`,
  bracketHeader:
    windowSize < 960
      ? `${PLL_IMAGE_URL}/2024/08/500x60_2024.jpg`
      : `${PLL_IMAGE_URL}/2024/08/1400x60_2024.jpg`,
  fantasyShare: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/05/IMG_7199-scaled.webp`,
  pllnHomeCallout: `https://${MAIN_PLL_URL}/wp-content/uploads/2023/07/pllnhome-callout.webp`,
  unleashedLogoAllStar: `https://${MAIN_PLL_URL}/wp-content/uploads/2024/01/unleashed-all-star-logo.webp`,
  pllNationLogo: `${PLL_IMAGE_URL}/2024/01/PLL_Nation_Logo_white.webp`,
  wllShield: `${NEW_PLL_IMAGE_URL}/Logos/2024/wll_primary_logo.png`,
  ticketmasterLogo: `https://${MAIN_PLL_URL}/wp-content/uploads/2025/05/Ticketmaster_logo_25.webp`,
  fastestShotBanner: `https://${MAIN_PLL_URL}/wp-content/uploads/2025/05/1728x330.webp`,
}

export const BROADCASTER_LINKS = {
  collegeDraft: `https://www.espn.com/watch/player?id=a6c83ff4-2e6e-4cd1-bd76-8922289141f8`,
  generalESPNPlus: `https://plus.espn.com/pll`,
}

export const DYNAMIC_LINK_CONFIG = {
  baseUrl: APP_LINK_BASE_URL,
  //iOS bundle ID
  ibi: process.env.REACT_APP_IOS_BUNDLE_ID || 'com.pll.PLL',

  //iOS App Store ID
  isi: process.env.REACT_APP_APP_STORE_ID || '1618489206',

  //Android package name
  apn: process.env.REACT_APP_APP_ANDROID_PACKAGE_ID || 'com.pll.pllandroid',
  shareTitle: 'Download the PLL App',
}

export const HOME_OFFERINGS = [
  {
    title: 'PLL App',
    imageUrl: 'https://img.premierlacrosseleague.com/Teams/2022/Logo/pll-app-icon.jpg',
    subText: `League News | Live Scores | Weekly Fantasy`,
    buttonText: `Download App`,
    link: PLL_LINKS.generalAppLink,
  },
  {
    title: '',
    imageUrl:
      'https://premierlacrosseleague.com/wp-content/uploads/2021/03/sbjAward1X@2x.jpg',
    subText: ``,
    buttonText: ``,
    link: ``,
  },
  {
    title: 'Top Shelf',
    imageUrl:
      'https://premierlacrosseleague.com//wp-content/uploads/2021/07/16x9_PLLxTopShelf_Logo-9900000000079e3c-300x169.jpeg',
    subText: `Play PLL's first mobile game`,
    buttonText: `Play Now`,
    link: `https://premierlacrosseleague.com/pll-top-shelf`,
  },
]

export const SEARCH_CONFIG = {
  pll: process.env.NODE_ENV === 'production' ? 'prod_pll_general' : 'test_PLL',
  shop: 'shopify_products',
  players: 'prod_players',
  videos: 'prod_videos',
  posts: 'prod_articles',
  teams: 'prod_teams',
}

export const yearDropdown = [
  { label: '2025', value: 2025 },
  { label: '2024', value: 2024 },
  { label: '2023', value: 2023 },
  { label: '2022', value: 2022 },
  { label: '2021', value: 2021 },
  { label: '2020', value: 2020 },
  { label: '2019', value: 2019 },
]

export const allYearsLabel = { label: 'All Years', value: 0 }

export const yearDropdownAllYears = [
  { label: 'All Years', value: 0 },
  { label: '2025', value: 2025 },
  { label: '2024', value: 2024 },
  { label: '2023', value: 2023 },
  { label: '2022', value: 2022 },
  { label: '2021', value: 2021 },
  { label: '2020', value: 2020 },
  { label: '2019', value: 2019 },
]

export const transactionTypes = [
  { label: 'All Types', value: 'All' },
  { label: 'Injured List', value: 'Injured List' },
  { label: 'Player Pool', value: 'Player Pool' },
  { label: 'PUP', value: 'PUP List' },
  { label: 'Holdout', value: 'Holdout List' },
  { label: 'College Draft', value: 'College Draft' },
  { label: 'Travel', value: 'Unavailable To Travel' },
  { label: 'Suspended', value: 'Suspended' },
  { label: 'Entry Draft', value: 'Entry Draft' },
  { label: 'Retired', value: 'Retired' },
]

export const contractStatusTypes = [
  { label: 'By Status', value: 'All' },
  { label: 'Injured List', value: 'Injured List' },
  { label: 'Excused Absence', value: 'Excused Absence' },
  { label: 'PUP', value: 'PUP List' },
  { label: 'Holdout', value: 'Holdout List' },
  { label: 'Pending Contract', value: 'Pending Contract' },
  { label: 'Travel', value: 'Unavailable To Travel' },
  { label: 'Military', value: 'Military List' },
]

export const contractEndDates = [
  { label: 'By End Date', value: 'All' },
  { label: 'Pending', value: 'Pending Contract' },
  { label: '2024', value: '2024' },
  { label: '2025', value: '2025' },
  { label: '2026', value: '2026' },
  { label: '2027', value: '2027' },
  { label: '2028', value: '2028' },
]

export const positionTypes = [
  { label: 'By Position', value: 'All' },
  { label: 'Attack', value: 'A' },
  { label: 'Midfield', value: 'M' },
  { label: 'Faceoff', value: 'FO' },
  { label: 'Short Stick D-Mid', value: 'SSDM' },
  { label: 'Long Stick Midfield', value: 'LSM' },
  { label: 'Defense', value: 'D' },
  { label: 'Goalie', value: 'G' },
]

export const DiscordIds = {
  main: '910274375406718987',
}
